import { css } from 'styled-components';
import { APPEARANCES, ISCardProps } from './models';

export const Card = ({
  theme,
  appearance,
  isLoading,
  isSelected,
  isSelectable,
  isExpandable,
  breakingSizeQuery,
}: ISCardProps) => {
  const expandedCard = `
        > .expanded-content {
            color: ${isSelected ? 'white' : 'inherit'};
            max-height: 500px;
            border-top: 1px solid ${theme.colors.disabledBG};
            margin-top: 5px;
        }
    `;

  const blueCard = `
        background: ${theme.colors.primaryBackground};
        border: 3px solid ${theme.colors.primaryBright};
        color: ${theme.colors.white};
        h3 {
            color: ${theme.colors.lightBlue}
        }
        > .expanded-content {
            color: ${theme.colors.lightGray}!important;
            border-top: 1px solid ${theme.colors.lightGray}!important;
            max-height: 500px;
        }
    `;

  return css`
    border: 0;
    border-radius: ${theme.borderRadiusMedium}px;
    cursor: ${isSelected ? 'pointer' : 'default'};
    display: inline-block;
    padding: 14px;
    position: relative;
    user-select: none;
    background: ${theme.colors.white};
    color: ${theme.colors.primaryBackground};
    font-size: 14px;
    line-height: 21px;
    box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
    border: 3px solid transparent;

    > .card-loader {
      display: none;
      width: 100%;
      height: 100%;
      color: white;
      position: absolute;
      align-items: center;
      box-sizing: border-box;
      padding: 10%;
      top: 0;
      left: 0;

      & h1 {
        padding: 10%;
        font-weight: 800;
        font-size: 30px;
        z-index: 2;
      }

      > .flower-icon {
        z-index: 2;
      }

      > .shimmer {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
      }
    }

    > .card-content {
      position: relative;
      min-height: 80px;
      min-width: 230px;
      display: flex;
      justify-content: center;
      ${isLoading &&
      `
                visibility: hidden;
            `}
    }

    > .expanded-content {
      max-height: 0;
      overflow: hidden;
      transition: all 0.15s ease;
    }

    > .arrow {
      position: absolute;
      top: 40px;
      right: 20px;
      cursor: pointer;
    }

    &.selected {
      ${blueCard}
    }

    ${isLoading &&
    `
            background: ${theme.colors.grayWhite};
            color: ${theme.colors.white};
            > .card-loader {
                display: flex;
            }
        `};

    ${isExpandable &&
    `
            &.expanded {
                ${expandedCard}
            }
        `};

    @media only screen and ${breakingSizeQuery || '(min-width: 1320px)'} {
      ${expandedCard}
      .arrow {
        display: none;
      }

      .card-content {
        min-width: 237px;
        ${isLoading && `min-height: 156px`};
      }
    }

    ${(isSelected || appearance === APPEARANCES.ACCENT) &&
    `
            ${blueCard}
        `}

    ${isSelectable &&
    `
            cursor: pointer;
        `}
  `;
};
